import { create } from "zustand";
import ApiRequest from "./ApiRequest";

const useStore = create((set, get) => ({
  header: {
    BASIC_ALERT_DURATION: 4000,
    imageModal: false,
    templateModal: false,
    resultModal: false,
    imageModalSelectMode: false,
    imageModalType: "all",
    disableImageModalType: false, //이미지관리 모달 유형 선택 읽기전용 전환용
    selectedSingleImageData: null, //템플릿 이미지 선택시 선택된 이미지
    imageModalSubType: "",
    openModal: (modalName) => set((state) => ({ header: { ...state.header, [modalName]: true } })),
    closeModal: (modalName) => set((state) => ({ header: { ...state.header, [modalName]: false, imageModalSelectMode: false, imageModalType: "all", disableImageModalType: false, imageModalSubType: "" } })),
    setImageModalSelectMode: (flag) => set((state) => ({ header: { ...state.header, imageModalSelectMode: flag } })),
    setImageModalType: (type) => set((state) => ({ header: { ...state.header, imageModalType: type } })),
    setImageModalSubtype: (subType) => set((state) => ({ header: { ...state.header, imageModalSubType: subType } })),
    setDisableImageModalType: (flag) => set((state) => ({ header: { ...state.header, disableImageModalType: flag } })),
    setSelectedSingleImageData: (data) => set((state) => ({ header: { ...state.header, selectedSingleImageData: data } })),

    journeyType: "",
    setJourneyType: (data) => set((state) => ({ header: { ...state.header, journeyType: data } })),

    newImageDialog: false,
    openNewImageDialog: () => set((state) => ({ header: { ...state.header, newImageDialog: true } })),
    closeNewImageDialog: () => set((state) => ({ header: { ...state.header, newImageDialog: false } })),

    newTemplateDialog: false,
    openNewTemplateDialog: () => set((state) => ({ header: { ...state.header, newTemplateDialog: true } })),
    closeNewTemplateDialog: () => set((state) => ({ header: { ...state.header, newTemplateDialog: false, isCloneMode: false, isTemplateReadOnlyMode: false, isTemplateEditMode: false, templateForEditMode: {}, selectedSingleImageData: null } })),

    loadingModal: false,
    onLoading() {
      set((state) => ({ header: { ...state.header, loadingModal: true } }));
    },
    offLoading() {
      set((state) => ({ header: { ...state.header, loadingModal: false } }));
    },

    actId: "",
    setActId: (data) => set((state) => ({ header: { ...state.header, actId: data } })),

    journeyId: "",
    setJourneyId: (data) => set((state) => ({ header: { ...state.header, journeyId: data } })),

    interactionId: "",
    setInteractionId: (data) => set((state) => ({ header: { ...state.header, interactionId: data } })),

    eventId: "",
    setEventId: (data) => set((state) => ({ header: { ...state.header, eventId: data } })),

    initActivity: {},
    setInitActivity: (data) => set((state) => ({ header: { ...state.header, initActivity: data } })),

    isSpinner: false,
    setIsSpinner: (data) => set((state) => ({ header: { ...state.header, isSpinner: data } })),

    org: {},
    token: "",
    extensionId: "",
    /** SFMC eventDefinitions 응답에서 Data Extension GUID 추출 */
    pickDataExtensionId: (extensionRes) => {
      if (!extensionRes || typeof extensionRes !== "object") return "";
      return (
        extensionRes.dataExtensionId ||
        extensionRes.dataExtension?.Id ||
        extensionRes.dataExtension?.id ||
        ""
      );
    },
    /** 토큰 발급 후에 호출되거나, interaction 이후 보강용 — eventDefinitionId가 있을 때만 DE 조회 */
    syncExtensionFromEventDefinition: async function (eventDefinitionId) {
      const head = get().header;
      const ev = eventDefinitionId || head.eventId;
      if (!ev || !head.token || !head.org?.baseUrl) return;
      const url = "https://" + head.org.baseUrl;
      try {
        const extension_res = await ApiRequest.post("/channel/getDataExtension", { id: ev, url: url, token: head.token });
        const extId = get().header.pickDataExtensionId(extension_res);
        if (extId) {
          set((state) => ({ header: { ...state.header, extensionId: extId } }));
        }
      } catch (e) {
        console.error("syncExtensionFromEventDefinition failed:", e);
      }
    },
    getAuth: async (eid, mid) => {
      if (eid == null || mid == null || String(eid).trim() === "" || String(mid).trim() === "") {
        console.warn("getAuth skipped: EID 또는 MID가 없음", { eid, mid });
        return;
      }
      const query = "SELECT o.*, c.bsid, c.passwd FROM organization AS o LEFT OUTER JOIN customer AS c ON c.id = o.customerId WHERE o.EID = @inputEID AND o.MID = @inputMID";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputEID: String(eid), inputMID: String(mid) } });
      //console.log(res.recordset)
      if (res.recordset.length > 0) {
        const result = res.recordset[0],
          url = "https://" + result.baseUrl,
          token_res = await ApiRequest.post("/channel/getTokens", { url: url, clientId: result.clientId, secretKey: result.secretKey, mid, mid });
        //console.log(token_res.access_token, get().header.eventId)
        set((state) => ({ header: { ...state.header, org: result, ...(token_res.access_token && { token: token_res.access_token }) } }));
        const eventDefId = get().header.eventId;
        if (token_res.access_token && eventDefId) {
          const extension_res = await ApiRequest.post("/channel/getDataExtension", { id: eventDefId, url: url, token: token_res.access_token });
          const extId = get().header.pickDataExtensionId(extension_res);
          if (extId) {
            set((state) => ({ header: { ...state.header, extensionId: extId } }));
          }
        }
      }
    },

    images: [],
    getImages: async function () {
      const { onLoading, offLoading } = get().header;
      onLoading.call(this);
      const query = "SELECT * FROM image";
      const res = await ApiRequest.post("/db/fetchData", { query });
      console.log(res.recordset);
      if (res.recordset.length > 0) {
        set((state) => ({ header: { ...state.header, images: res.recordset } }));
      }
      offLoading.call(this);
    },

    templates: [],
    getTemplates: async function () {
      const { onLoading, offLoading } = get().header;
      onLoading.call(this);
      const query = "SELECT * FROM template";
      const res = await ApiRequest.post("/db/fetchData", { query });
      console.log(res.recordset);
      if (res.recordset.length > 0) {
        set((state) => ({ header: { ...state.header, templates: res.recordset } }));
      }
      offLoading.call(this);
    },

    channels: [],
    selectedChannel: {},
    setSelectedChannel: (data) => set((state) => ({ header: { ...state.header, selectedChannel: data } })),
    getChannels: async function () {
      const { org } = get().header;
      const query = "SELECT * FROM channel WHERE organizationId = @inputOrg";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputOrg: org.id } });
      //console.log('channels : ', org)
      if (res.recordset.length > 0) {
        set((state) => ({ header: { ...state.header, channels: res.recordset } }));
      }
    },

    logs: [],
    getLogs: async function () {
      const { journeyId } = get().header;
      const query = "SELECT * FROM logs WHERE journeyId = @journeyId";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { journeyId: journeyId } });
      //console.log('channels : ', org)
      if (res.recordset.length > 0) {
        set((state) => ({ header: { ...state.header, logs: res.recordset } }));
      }
    },

    isMMS: false,
    setIsMMS: (data) => set((state) => ({ header: { ...state.header, isMMS: data } })),

    isAd: false,
    setIsAd: (data) => set((state) => ({ header: { ...state.header, isAd: data } })),

    selectedTemplate: {},
    setSelectedTemplate: (data) => {
      const { setIsMMS } = get().header;
      setIsMMS(false);
      console.log(data);
      console.log(JSON.parse(data.buttons)[0]);
      set((state) => ({ header: { ...state.header, selectedTemplate: data } }));
    },

    //channels: [],
    selectedChannelName: "",
    setSelectedChannelName: (data) => set((state) => ({ header: { ...state.header, selectedChannelName: data } })),
    selectedPhone: "",
    setSelectedPhone: (data) => set((state) => ({ header: { ...state.header, selectedPhone: data } })),

    getChannels: async function () {
      const { onLoading, offLoading } = get().header;
      onLoading.call(this);
      const query = "SELECT * FROM channel";
      const res = await ApiRequest.post("/db/fetchData", { query });
      console.log(res.recordset);
      if (res.recordset.length > 0) {
        set((state) => ({ header: { ...state.header, channels: res.recordset } }));
      }
      offLoading.call(this);
    },

    setDate: function (d) {
      return [d.getFullYear(), d.getMonth(), d.getDate(), d.getDay(), d.getHours(), d.getMinutes(), d.getSeconds()].join(".");
    },

    save: false,

    isTemplateReadOnlyMode: false,
    isTemplateEditMode: false,
    isCloneMode: false,
    templateForEditMode: {},
    setTemplateEditMode: (isReadOnly, template, isEditMode, isCloneMode) => {
      const { openNewTemplateDialog } = get().header;
      console.log(template);
      console.log(isReadOnly);
      set((state) => ({ header: { ...state.header, templateForEditMode: template, isTemplateReadOnlyMode: isReadOnly, isTemplateEditMode: isEditMode, isCloneMode: isCloneMode } }));
      openNewTemplateDialog();
    },
  },
  preview: {
    content: "Preview Content",
    setContent: (content) => set((state) => ({ preview: { ...state.preview, content } })),
    isVar: false,
    setIsVar: (data) => set((state) => ({ preview: { ...state.preview, isVar: data } })),
    variabledContent: "",
    page: 0,
    setPage: (data) => set((state) => ({ preview: { ...state.preview, page: Number(data) } })),
    setVariabledContent: (data) => set((state) => ({ preview: { ...state.preview, variabledContent: data } })),
    variabledContents: [],
    setVariabledContents: (data) => set((state) => ({ preview: { ...state.preview, variabledContents: data, ...(data.length > 0 && { variabledContent: data[0] }) } })),
    open: false,
    setOpen: (data) => set((state) => ({ preview: { ...state.preview, open: data } })),
    variableSwitchFlag: false,
    setVariableSwitchFlag: (data) => set((state) => ({ preview: { ...state.preview, variableSwitchFlag: data } })),
    phoneMessageSwitchFlag: false,
    setPhoneMessageSwitchFlag: (data) => set((state) => ({ preview: { ...state.preview, phoneMessageSwitchFlag: data } })),
  },
  mapper: {
    defields: [],
    setDefields: (data) => set((state) => ({ mapper: { ...state.mapper, defields: data } })),
    sendTarget: { value: "", type: "" },
    setSendTarget: (data) => set((state) => ({ mapper: { ...state.mapper, sendTarget: data } })),
    datas: [],
    setDatas: (data) => set((state) => ({ mapper: { ...state.mapper, datas: data } })),
    contacts: [],
    getContacts: async () => {
      const headData = get().header,
        contact_res = await ApiRequest.post("/channel/getRowData", { extendId: headData.extensionId, baseUrl: headData.org.baseUrl, token: headData.token });
      if (contact_res.items && contact_res.items.length > 0) {
        //console.log(contact_res.items)
        await set((state) => ({
          mapper: {
            ...state.mapper,
            contacts: contact_res.items.reduce((a, c) => {
              a.push({ ...c.keys, ...c.values });
              return a;
            }, []),
          },
        }));
      }
    },

    setMapping: async () => {
      //console.log(get().header.selectedTemplate)
      const headData = get().header,
        mappingData = get().mapper,
        query = "SELECT * FROM mapping WHERE eventId = @inputId",
        check_res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputId: headData.actId } }),
        res_length = Object.keys(check_res.recordsets[0]),
        target = {
          tableName: "mapping",
          data: {
            eventId: headData.actId,
            mapping: JSON.stringify(mappingData.datas),
            templateId: headData.selectedTemplate.Id,
            channelCode: headData.selectedChannel.channelCode,
            imageCode: "",
            extendId: headData.extensionId,
            ismms: headData.isMMS,
            adFlag: headData.isAd,
            journeyId: headData.journeyId,
            versionId: headData.interactionId,
            recipientMapping: JSON.stringify(mappingData.sendTarget),
            organizationId : headData.org.id,
            validationError: null,
          },
          ...(res_length.length > 0 && { filter: { eventId: headData.actId } }),
        },
        res = await ApiRequest.post(res_length.length > 0 ? "/db/updateData" : "/db/insertData", target);
      //console.log(check_res, headData.initActivity)
      console.log(mappingData.sendTarget);
      set((state) => ({
        header: { ...state.header, save: true },
        mapper: {
          ...state.mapper,
          ...(state.mapper.initData &&
            Object.keys(state.mapper.initData).length > 0 && {
              initData: { ...state.mapper.initData, validationError: null },
            }),
        },
      }));
      return;
    },

    initData: {},
    isInit: true,
    toggleIsInit: () => set((state) => ({ mapper: { ...state.mapper, isInit: false } })),
    setInitData: async (eventId) => {
      const headData = get().header;
      const query = "SELECT * FROM mapping m LEFT OUTER JOIN template t ON t.Id = m.templateId WHERE eventId = @inputEventId";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputEventId: eventId } });
      //console.log('initData : ', res)
      if (res.recordset.length > 0) {
        console.log("initData : ", res.recordset[0]);
        console.log("journey : ", headData.journeyId);
        if (res.recordset[0].journeyId === headData.journeyId) {
          set((state) => ({ mapper: { ...state.mapper, initData: res.recordset[0] } }));
        } else {
          //console.log(headData.initActivity)
          let data = headData.initActivity,
            identifier = btoa(headData.setDate(new Date()) + Math.random() * 10),
            arg = data.arguments.execute.inArguments;
          for (let ar of arg) {
            if (ar["identifier"]) ar["identifier"] = identifier;
          }
          set((state) => ({ header: { ...state.header, actId: identifier, initActivity: { ...data } } }));
        }
      }
    },

    getTemplate: async function (id) {
      const query = "SELECT * FROM template WHERE id = @inputId";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputId: id } });
      console.log(res.recordset);
      if (res.recordset.length > 0) set((state) => ({ header: { ...state.header, selectedTemplate: res.recordset[0] } }));
    },

    getChannel: async function (id) {
      const query = "SELECT * FROM channel WHERE channelCode = @inputCode";
      const res = await ApiRequest.post("/db/fetchData", { query: query, params: { inputCode: id } });
      console.log(res.recordset);
      if (res.recordset.length > 0) set((state) => ({ header: { ...state.header, selectedChannel: res.recordset[0], selectedChannelName: res.recordset[0].channelName, selectedPhone: res.recordset[0].channelPhone } }));
    },
  },
}));

export default useStore;